import React, { Fragment, useEffect, useContext } from "react";
import WorkOrderGrid, { currentPage } from "./wo_grid/WorkOrderGrid";
import WorkOrderDetails from "./wo_details/WorkOrderDetails";
import { observer } from "mobx-react-lite";
import WorkOrderStore from "../../../app/stores/workorderStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import UserAuthStore from "../../../app/stores/userauthStore";

interface IProps {}




const WorkOrderDashboard: React.FC<IProps> = props => {
  const workOrderStore = useContext(WorkOrderStore);
  const userAuthStore = useContext(UserAuthStore);

  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)
  let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
  let CurrentModule = sessionStorage.getItem("module")

  useEffect(() => {
    userAuthStore.HydrateAuthState();
   }, [userAuthStore]);



  useEffect(() => {
    workOrderStore.loadWorkOrders(CurrentModule!,sessionObj.Username,sessionObj.Client.Id,);
  }, [workOrderStore, CurrentModule]);

  if (workOrderStore.loadinginitial)
    return <LoadingComponent content={"Loading: " + CurrentModule} inverted={true} />;

  return (
    <Fragment>
      <WorkOrderGrid workorders={workOrderStore.workorders} />
      <WorkOrderDetails />
    </Fragment> 
  );
};

export default observer(WorkOrderDashboard);
